import React, { useState, useEffect, useCallback } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FiLogOut, FiUser } from "react-icons/fi";
import { BsBellFill, BsBell } from "react-icons/bs";
import logo from '../../../assets/images/logo.svg';
import logoMobile from '../../../assets/images/logo-mobile.svg';
import menuIcon from '../../../assets/images/menu.svg';

import styles from './Nav.module.scss';
import { useGlobalContext } from '../../../context/GlobalContext';
import { getNotifsAction } from '../../../actions/authActions';
import { TOOL_ID } from '../../../actions';
import Notifs from '../Notifs/Notifs';
import { FaList } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';

export default function Nav({ logout }) {

  const [context, dispatch] = useGlobalContext();

  const [isHidden, setIsHidden] = useState(true);
  const [notifIsOpen, setNotifsIsOpen] = useState(false)
  const [logoIsHidden, setLogoIsHidden] = useState(true);
  const [isMenu, setIsMenu] = useState(false);

  const getNotifs = useCallback(() => { getNotifsAction(dispatch, 'Medocta') }, [dispatch]);

  const location = useLocation();

  const role = context.auth.userAuth?.tools?.find((t) => t.tool === TOOL_ID)?.role;
  const isNew = context?.auth?.notifs?.find(n => n.new);

  async function handleLogout() {
    await logout();
    setIsMenu(false);
  }

  useEffect(() => {
    if (location.pathname === "/login" || location.pathname === "/data-policy" || location.pathname === "/transparency" || location.pathname === "/" || location.pathname.split("/")[1] === 'ask' || location.pathname.split("/")[1] === 'satisfaction') {
      setIsHidden(true);
      setNotifsIsOpen(false)
      if (location.pathname.split("/")[1] === 'ask' || location.pathname.split("/")[1] === 'satisfaction') {
        setLogoIsHidden(false);
      } else {
        setLogoIsHidden(true);
      }
    } else {
      setIsHidden(false);
      setLogoIsHidden(true);
    }
  }, [location]);

  useEffect(() => {
    if (notifIsOpen) getNotifs();
  }, [notifIsOpen, getNotifs]);

  if (!role) return null;

  return (
    <>
      <nav className={`${styles['nav-mobile']} ${isHidden ? "" : styles['nav-is-active']}`}>
        <NavLink to="/">
          <img src={logoMobile} alt="medocta" />
        </NavLink>
        <button
          type="button"
          onClick={() => setIsMenu(true)}
          className={styles.toggleMenu}
        >
          <img src={menuIcon} alt="medocta" />
        </button>
        {isNew && <div className={styles.puce} />}
      </nav>
      <nav className={`${styles.nav} ${isHidden ? "" : styles['nav-is-active']}`}>
        <div className={styles.content}>

          <NavLink to="/">
            <img src={logo} alt="medocta" />
          </NavLink>

          <div className={styles.links}>
            {role === "Admin" &&
              <>
                <NavLink to="/dashboard" activeClassName={styles['is-active']} >DASHBOARD</NavLink>
                <NavLink to="/question" activeClassName={styles['is-active']} >QUESTIONS/RÉPONSES</NavLink>
                {/* <NavLink to="/answers" activeClassName={styles['is-active']}>RÉPONSES</NavLink> */}
                <NavLink to="/validations" activeClassName={styles['is-active']}>VALIDATIONS</NavLink>
                <NavLink to="/answers-types" activeClassName={styles['is-active']}>RÉPONSES TYPES</NavLink>
              </>
            }
            {role === "Owner" &&
              <>
                <NavLink to="/dashboard" activeClassName={styles['is-active']} >DASHBOARD</NavLink>
                <NavLink to="/question-assign" activeClassName={styles['is-active']} >MES QUESTIONS</NavLink>
                <NavLink to="/question" activeClassName={styles['is-active']} >QUESTIONS</NavLink>
              </>
            }
            {role === "Member" &&
              <>
                <NavLink to="/dashboard" activeClassName={styles['is-active']} >DASHBOARD</NavLink>
                <NavLink to="/question-member" activeClassName={styles['is-active']} >MES QUESTIONS</NavLink>
              </>
            }

          </div>

          <div className={styles.icons}>

            {role === "Admin" &&
              <NavLink className={styles.changes} to="/changes">
                <FaList size={22} color={"#192243"} />
              </NavLink>
            }

            <button onClick={() => setNotifsIsOpen(!notifIsOpen)}>
              {context.auth?.notifs?.find(n => n.new) ?
                <>
                  <BsBellFill size={22} color={"#FFA56D"} />
                  <div className={styles.notifs}>
                    <p>{context.auth?.notifs?.filter(n => n.new).length}</p>
                  </div>
                </>
                :
                <BsBell size={22} color={"#192243"} />
              }
            </button>

            <NavLink to="/account">
              <FiUser size={22} color={"#192243"} />
            </NavLink>

            <button className={styles.logout} onClick={() => logout()}>
              <FiLogOut size={22} color={"#192243"} />
            </button>

          </div>

        </div>
      </nav>
      <Notifs
        isOpen={notifIsOpen}
        notifs={context.auth?.notifs}
      />
      <div className={`${styles.logo} ${logoIsHidden ? "" : styles['logo-is-active']}`}>
        <div className={styles.content}>
          <NavLink to="/">
            <img src={logo} alt="medocta" />
          </NavLink>
        </div>
      </div>
      <div className={`${styles.menu} ${isMenu ? styles.open : ''}`}>
        <h1>menu</h1>
        <button
          type="button"
          onClick={() => setIsMenu(false)}
          className={styles.close}
        >
          <MdClose />
        </button>
        <div className={styles.links}>
          {role === "Admin" &&
            <>
              <NavLink to="/dashboard" onClick={() => setIsMenu(false)} activeClassName={styles['is-active']} >DASHBOARD</NavLink>
              <NavLink to="/question" onClick={() => setIsMenu(false)} activeClassName={styles['is-active']} >QUESTIONS/RÉPONSES</NavLink>
              {/* <NavLink to="/answers" activeClassName={styles['is-active']}>RÉPONSES</NavLink> */}
              <NavLink to="/validations" onClick={() => setIsMenu(false)} activeClassName={styles['is-active']}>VALIDATIONS</NavLink>
              <NavLink to="/answers-types" onClick={() => setIsMenu(false)} activeClassName={styles['is-active']}>RÉPONSES TYPES</NavLink>
            </>
          }
          {role === "Owner" &&
            <>
              <NavLink to="/dashboard" onClick={() => setIsMenu(false)} activeClassName={styles['is-active']} >DASHBOARD</NavLink>
              <NavLink to="/question-assign" onClick={() => setIsMenu(false)} activeClassName={styles['is-active']} >MES QUESTIONS</NavLink>
              <NavLink to="/question" onClick={() => setIsMenu(false)} activeClassName={styles['is-active']} >QUESTIONS</NavLink>
            </>
          }
          {role === "Member" &&
            <>
              <NavLink to="/dashboard" onClick={() => setIsMenu(false)} activeClassName={styles['is-active']} >DASHBOARD</NavLink>
              <NavLink to="/question-member" onClick={() => setIsMenu(false)} activeClassName={styles['is-active']} >MES QUESTIONS</NavLink>
            </>
          }
          {role === "Admin" &&
            <NavLink className={styles.changes} onClick={() => setIsMenu(false)} activeClassName={styles['is-active']} to="/changes">
              Audit Trail
            </NavLink>
          }
          {/* <button onClick={() => setNotifsIsOpen(!notifIsOpen)}>
            {context.auth?.notifs?.find(n => n.new) ?
              <>
                Notifications
                <div className={styles.notifs}>
                  <p>{context.auth?.notifs?.filter(n => n.new).length}</p>
                </div>
              </>
              :
              <>
                Notifications
                <div className={styles.notifs}>
                  <p>{context.auth?.notifs?.filter(n => n.new).length}</p>
                </div>
              </>
            }
          </button> */}
          <NavLink to="/notifs" activeClassName={styles['is-active']} onClick={() => setIsMenu(false)}>
            Notifications
            {isNew &&
              <div className={styles.count}>
                {context?.auth?.notifs?.filter(n => n.new)?.length}
              </div>
            }
          </NavLink>

          <NavLink to="/account" activeClassName={styles['is-active']} onClick={() => setIsMenu(false)}>
            Mon profil
          </NavLink>

          <button className={styles.logout} onClick={() => handleLogout()}>
            Déconnexion
          </button>
        </div>
      </div>
    </>

  )
}
